import {Component, Input, OnInit, ViewChild} from '@angular/core'
import {RichsnipetService} from 'dmmp-services'
import {MediaInterface} from '../../../interfaces'
import {VideoPlayerComponent} from '../../shared/video-player/video-player.component'

@Component({
  selector: 'dmmp-slide-view',
  templateUrl: './slide-view.component.html'
})
export class SlideViewComponent implements OnInit {

  @Input() slideInfo
  @Input() mode
  schema
  _videoState
  @Input() set videoState(val) {
    this._videoState = val
    this.stopVideo()
  }

  @ViewChild('videoPlayer') videoPlayer: VideoPlayerComponent
  medias: MediaInterface[] = [
    {style: 'max_650x650', media: '(max-width:650px) AND (min-width:326px)'},
    {style: 'max_325x325', media: '(max-width:325px)'},
  ]

  constructor(private richsnipetService: RichsnipetService) {
  }

  ngOnInit(): void {
    if (this.mode === 'video') {
      if (this.slideInfo?.image?.length > 0
        && this.slideInfo?.video?.length > 0) {
        this.schema = this.richsnipetService.setupJsonBeneficVideo(this.slideInfo)
      }
    }

  }

  stopVideo() {
    this.videoPlayer?.stopVideo()
  }

}
